// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-2e8319a2]{border-color:var(--brand-primary);background-color:var(--brand-primary);--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
